import { createAction } from 'typesafe-actions';
import { IPumpingStationFilterType } from '../../../../@types/model/masterData/pumpingStation/filterType';

export default class MasterDataPumpingStationFilterTypeActions {
    public static readonly set = createAction('MASTER_DATA_SET_PUMPING_STATION_FILTER_TYPE', resolve => (pumps : Array<IPumpingStationFilterType>) => resolve(pumps));
    public static readonly setLoading = createAction('MASTER_DATA_SET_PUMPING_STATION_FILTER_TYPE_LOADING', resolve => (isLoading : boolean) => resolve(isLoading));
}